import { render, staticRenderFns } from "./NormMenu.vue?vue&type=template&id=5632a4d2&scoped=true&"
import script from "./NormMenu.vue?vue&type=script&lang=js&"
export * from "./NormMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5632a4d2",
  null
  
)

export default component.exports